import { StrictRouteConfig } from "@/router/router";

export const floorRoutes: StrictRouteConfig[] = [
    {
        path: "/customers/:customerId/offices/:officeId/floors",
        name: "floors",
        component: () => import(/* webpackChunkName: "floor" */ "@/views/office/floors.vue"),
        meta: {
            requiresAuth: true,
            label: "Floors",
            title: "Manage floors",
            includeInSubNavigation: true,
            icon: "map-outline",
            matchExact: false,
            path: ["dashboard", "offices", "office", "floors"],
            order: 30,
        },
    },
    {
        path: "/customers/:customerId/offices/:officeId/floors/:floorId",
        name: "floor",
        component: () => import(/* webpackChunkName: "floor" */ "@/views/office/floor.vue"),
        meta: {
            requiresAuth: true,
            label: "Floor",
            includeInNavigation: false,
            matchExact: true,
            path: ["dashboard", "offices", "office", "floors", "floor"],
        },
    },
    {
        path: "/customers/:customerId/offices/:officeId/floors/:floorId/zones",
        name: "floor-zones",
        component: () => import(/* webpackChunkName: "floor" */ "@/views/office/floor-zones.vue"),
        meta: {
            requiresAuth: true,
            label: "Floor",
            includeInNavigation: false,
            matchExact: true,
            path: ["dashboard", "offices", "office", "floors", "floor"],
        },
    },
    {
        path: "/customers/:customerId/offices/:officeId/floors/:floorId/floorplan",
        name: "floor-floorplan",
        component: () => import(/* webpackChunkName: "floor" */ "@/views/office/floor-floorplan.vue"),
        meta: {
            requiresAuth: true,
            label: "Floor",
            includeInNavigation: false,
            matchExact: true,
            path: ["dashboard", "offices", "office", "floors", "floor"],
        },
    },
];
